let Teams;

const indexOf =
    [].indexOf ||
    function(item) {
        for (let i = 0, l = this.length; i < l; i++) {
            if (i in this && this[i] === item) return i;
        }
        return -1;
    };

Teams = (() => {
    function Teams() {
        let takenSeats;
        let totalSeats;
        totalSeats = parseInt($(".seats-total").text());
        takenSeats = parseInt($(".seats-taken").text());
        $(document).ready(() => {
            let blocker;
            let editSeatButtonReset;
            let editSeatForm;
            let editSeatsTimeout;
            let email_re;
            let getChargePeriod;
            let getChargeToday;
            let helpClasses;
            let helpTimeout;
            let lastFour;
            let memberList;
            let membersUrl;
            let owner;
            let removeMember;
            let renderMembers;
            let renderUrl;
            let seatChangePreview;
            let seatFeePeriod;
            let seatFeeProrated;
            let showEditSeatHelp;
            let teamSlug;
            let timeoutEditSeats;
            let toggleEditSeats;
            let updateSeats;
            helpTimeout = null;
            editSeatsTimeout = null;
            memberList = $(".manage-seats");
            teamSlug = memberList.data("teamSlug");
            membersUrl = `/${teamSlug}/members/json/`;
            renderUrl = `/${teamSlug}/members/render/`;
            blocker = $(".add-member-form-blocker");
            email_re = /.+[@].+/;
            owner = typeof $(".manage-seats").data("owner") !== "undefined";
            editSeatForm = $("#edit-seat-number");
            seatFeeProrated = editSeatForm.data("seatProrated");
            seatFeePeriod = editSeatForm.data("seatPeriod");
            lastFour = editSeatForm.data("lastFour");
            helpClasses = {
                default: "initial-help",
                tooFew: "too-few-seats",
                invalid: "invalid-number",
                jsonError: "json-error",
                successUp: "confirm-charge",
                successDown: "confirm-reduction",
                sameNumber: "same-number",
                cardError: "card-error",
                waiting: "waiting"
            };
            renderMembers = (members, container, action) => {
                let membersHtml;
                members = JSON.stringify({
                    team_members: members
                });
                membersHtml = "";
                $.ajax({
                    type: "POST",
                    url: renderUrl,
                    data: members,
                    success(data, status) {
                        $(container)
                            .parent()
                            .find(".loading")
                            .removeClass("visible")
                            .addClass("hidden");
                        if (action === "prepend") {
                            return $(container)
                                .prepend($(data))
                                .css("marginTop", "-130px")
                                .animate({
                                    marginTop: 0
                                });
                        } else {
                            return $(container)[action]($(data));
                        }
                    }
                });
            };
            updateSeats = (taken, total) => {
                if (total == null) {
                    total = totalSeats;
                }
                takenSeats = taken;
                totalSeats = total;
                $("span.seats-taken").text(taken);
                $("span.seats-total").text(total);
                if (takenSeats < totalSeats) {
                    blocker.hide();
                } else {
                    blocker.show();
                }
            };
            removeMember = (memberId, userId, memberEl) => {
                let url;
                url = `/${teamSlug}/members/remove/${memberId}/`;
                if (userId !== false) {
                    url = `${url + userId}/`;
                }
                return $.ajax({
                    type: "GET",
                    url,
                    success(data, status) {
                        if (data.ok) {
                            memberEl.slideUp({
                                duration: 400,
                                complete() {
                                    return $(this).remove();
                                }
                            });
                            return updateSeats(takenSeats - 1);
                        } else {
                            return console.log(data, status);
                        }
                    }
                });
            };
            showEditSeatHelp = helpClass => {
                let notErrorStates;
                let selector;
                let successStates;
                notErrorStates = [
                    "default",
                    "successUp",
                    "successDown",
                    "waiting"
                ];
                successStates = ["successUp", "successDown"];
                selector = `.${helpClasses[helpClass]}`;
                clearTimeout(helpTimeout);
                return (helpTimeout = setTimeout(() => {
                    $(".edit-seat-help").hide();
                    $(selector).show();
                    if (indexOf.call(notErrorStates, helpClass) >= 0) {
                        $(".seat-number").removeClass("error");
                    } else {
                        $(".seat-number").addClass("error");
                    }
                    if (indexOf.call(successStates, helpClass) >= 0) {
                        return editSeatButtonReset();
                    }
                }, 200));
            };
            getChargeToday = newSeats => {
                let chargeToday;
                chargeToday = (
                    (newSeats - totalSeats) *
                    seatFeeProrated
                ).toFixed(2);
                if (chargeToday <= 0) {
                    chargeToday = "0.00";
                }
                return chargeToday;
            };
            getChargePeriod = newSeats => {
                let chargePeriod;
                chargePeriod = (newSeats * seatFeePeriod).toFixed(2);
                return chargePeriod;
            };
            seatChangePreview = newSeats => {
                let helpClass;
                helpClass = "default";
                if (isNaN(newSeats) || newSeats < 1) {
                    helpClass = "invalid";
                } else if (newSeats < takenSeats) {
                    $(".seat-overage").text(takenSeats - newSeats);
                    helpClass = "tooFew";
                } else {
                    $(".seat-price-today").text(getChargeToday(newSeats));
                    $(".seat-price-period").text(getChargePeriod(newSeats));
                }
                return showEditSeatHelp(helpClass);
            };
            editSeatButtonReset = () => {
                let button;
                let buttonSpan;
                let defaultText;
                button = $(".edit-seat-number-submit");
                buttonSpan = button.find("span");
                defaultText = button.data("default");
                button
                    .data("confirm", "")
                    .removeClass("confirm processing success failure");
                buttonSpan.text(defaultText);
                return button.show();
            };
            toggleEditSeats = () => {
                let editSeats;
                editSeats = $("section.edit-seat-number");
                clearTimeout(editSeatsTimeout);
                if (editSeats.is(":visible")) {
                    return editSeats.slideUp();
                } else {
                    editSeatButtonReset();
                    return editSeats.slideDown();
                }
            };
            timeoutEditSeats = () => {
                let editSeats;
                editSeats = $("section.edit-seat-number");
                if (editSeats.is(":visible")) {
                    return (editSeatsTimeout = setTimeout(
                        () => editSeats.slideUp(),
                        7000
                    ));
                }
            };
            updateSeats(takenSeats);
            $.getJSON(membersUrl, ({ team, pending_invites, team_members }) => {
                let members;
                updateSeats(team.seats.taken, team.seats.total);
                if (owner) {
                    members = pending_invites.concat(team_members);
                } else {
                    members = team_members;
                }
                renderMembers(members, "#current-members", "append");
            });
            $("#seat-number")
                .on("keyup", function(e) {
                    let newSeats;
                    newSeats = parseInt($(this).val());
                    seatChangePreview(newSeats);
                    return editSeatButtonReset();
                })
                .on("keydown", e => {
                    if (e.keyCode === 13) {
                        return e.preventDefault();
                    }
                })
                .on("blur", function(e) {
                    let newSeats;
                    newSeats = parseInt($(this).val());
                    if (isNaN(newSeats) || newSeats < 1) {
                        newSeats = totalSeats;
                        $(this).val(newSeats);
                    }
                    return seatChangePreview(newSeats);
                });
            $("#edit-seat-number").on("submit", function(e) {
                let button;
                let buttonSpan;
                let chargeToday;
                let helpClass;
                let newSeats;
                let num;
                let params;
                let text;
                let url;
                e.preventDefault();
                button = $(this).find(".edit-seat-number-submit");
                buttonSpan = button.find("span");
                if (button.data("confirm") !== "true") {
                    newSeats = parseInt($("#seat-number").val());
                    chargeToday = getChargeToday(newSeats);
                    if (newSeats === totalSeats) {
                        return showEditSeatHelp("sameNumber");
                    } else if (newSeats < takenSeats) {
                        return false;
                    } else if (newSeats < totalSeats) {
                        num = totalSeats - newSeats;
                        text = num === 1 ? `${num} Seat` : `${num} Seats`;
                        buttonSpan.text(`Remove ${text}`);
                    } else {
                        buttonSpan.text(
                            `Charge $${chargeToday} on ${lastFour}`
                        );
                    }
                    button.data("confirm", "true");
                    button.addClass("confirm");
                    return $(".charge-amt").text(chargeToday);
                } else {
                    url = $(this).attr("action");
                    newSeats = $(this)
                        .find("#seat-number")
                        .val();
                    params = {
                        seats: newSeats
                    };
                    helpClass = "default";
                    if (isNaN(newSeats) || parseInt(newSeats) === 0) {
                        helpClass = "invalid";
                    } else {
                        if (newSeats >= takenSeats) {
                            button.addClass("processing");
                            $.post(
                                url,
                                params,
                                ({ error, subscription }, status) => {
                                    if (error) {
                                        showEditSeatHelp("cardError");
                                        editSeatButtonReset();
                                    }
                                    if (newSeats < totalSeats) {
                                        showEditSeatHelp("successDown");
                                    } else {
                                        showEditSeatHelp("successUp");
                                    }
                                    return updateSeats(
                                        takenSeats,
                                        subscription.quantity
                                    );
                                }
                            );
                        } else {
                            $(".seat-overage").text(takenSeats - newSeats);
                            helpClass = "tooFew";
                        }
                    }
                    return showEditSeatHelp(helpClass);
                }
            });
            $(".new-member-email").on("keyup", e => {
                let email;
                email = $("#new-member-email").val();
                if (email_re.exec(email)) {
                    return $(".add-member-notification").text("");
                }
            });
            $(".add-member-btn").on("click", function(e) {
                let addBtn;
                let email;
                let params;
                let url;
                e.preventDefault();
                addBtn = $(this);
                url = `/${teamSlug}/members/invite/`;
                email = $("#new-member-email").val();
                if (email_re.exec(email)) {
                    params = {
                        email
                    };
                    addBtn.prop("disabled", true);
                    $.post(
                        url,
                        params,
                        ({ success, invitation, team }, status) => {
                            addBtn.prop("disabled", false);
                            if (success) {
                                renderMembers(
                                    [invitation],
                                    "#current-members",
                                    "prepend"
                                );
                                updateSeats(team.seats.taken, team.seats.total);
                                return $(".new-member-email").val("");
                            } else {
                                return $(".add-member-notification").text(
                                    "Could not add team member"
                                );
                            }
                        }
                    ).fail(() => addBtn.prop("disabled", false));
                } else {
                    $(".add-member-notification").text(
                        "This doesn’t look like a valid email address"
                    );
                }
            });
            $("#current-members")
                .on("click", ".remove-member", function(e) {
                    let confirm;
                    let memberEl;
                    let memberId;
                    let userId;
                    e.preventDefault();
                    memberEl = $(this).parents(".team-member-detail");
                    memberId = memberEl.data("memberId");
                    userId = memberEl.data("userId");
                    confirm = memberEl.find(".team-member-confirm-remove");
                    return confirm
                        .fadeIn()
                        .on("click", ".yes-button", e => {
                            if (typeof userId === "number") {
                                return removeMember(memberId, userId, memberEl);
                            } else {
                                return removeMember(memberId, false, memberEl);
                            }
                        })
                        .on("click", ".no-button", e => confirm.fadeOut());
                })
                .on("click", ".resend-invite", function(e) {
                    let linkEl;
                    let memberToken;
                    let params;
                    e.preventDefault();
                    linkEl = $(this);
                    memberToken = $(this)
                        .parents(".team-member-detail")
                        .attr("data-token");
                    params = {
                        token: memberToken
                    };
                    $.ajax({
                        type: "POST",
                        url: `/${teamSlug}/members/invite/resend/`,
                        data: params,
                        success(data, status) {
                            linkEl.addClass("confirmed");
                            return setTimeout(
                                () => linkEl.removeClass("confirmed"),
                                3000
                            );
                        }
                    });
                })
                .on("click", ".copy-invite-url", function(e) {
                    let linkInput;
                    e.preventDefault();
                    linkInput = $(this)
                        .parents(".team-member-detail")
                        .find(".team-member-invite-url");
                    if (linkInput.is(":visible")) {
                        linkInput.slideUp();
                    } else {
                        linkInput.slideDown();
                        linkInput.trigger("select");
                    }
                })
                .on("click", ".team-member-confirm-remove-close", function(e) {
                    e.preventDefault();
                    return $(this)
                        .parents(".team-member-confirm-remove")
                        .fadeOut();
                });
            $("#new-member-email").on("focus", () =>
                $(".add-member-btn").addClass("darken")
            );
            $("#new-member-email").on("blur", () =>
                $(".add-member-btn").removeClass("darken")
            );
            $(".show-edit-seat-number").on("click", e => {
                e.preventDefault();
                return toggleEditSeats();
            });
            return $(".add-member-form-blocker a").on("click", e => {
                e.preventDefault();
                return toggleEditSeats();
            });
        });
    }

    return Teams;
})();

export default Teams;
